/*
 * @Author: Zhouqi
 * @Date: 2025-11-27 15:54:33
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-11-27 15:55:16
 */
import dynamic from 'next/dynamic';

const Pricing = dynamic(() => import('../../3.0/pricing/entry'), {
  ssr: false,
});

const VoiceClonePage: React.FC = () => {
  return <Pricing />;
};

export default VoiceClonePage;
